import {combineEpics, Epic} from "redux-observable";
import {Action} from "redux";
import WorkforceOneUserAccess from "./WorkforceOneUserAccess";
import WorkforceOneUserLoginEpic from "./WorkforceOneUserLoginEpic";
import WorkforceOneUserPortalPermission, { WorkforceOneUpdateUserPortalPermission } from "./WorkforceOneUserPortalPermission";
import WorkforceOneUserAutoCompanySelectionEpic from "./WorkforceOneUserAutoCompanySelectionEpic";
import WorkforceOneLoginPageReturn from "./WorkforceOneLoginPageReturn";
import WorkforceOneCompanySelectPageReturn from "./WorkforceOneCompanySelectPageReturn";
import WorkforceOneLogOutFromPasswordReset from "./WorkforceOneLogOutFromPasswordReset";
import WorkforceOnePasswordResetRequest from "./WorkforceOnePasswordResetRequest";
import WorkforceOneSSOUserLoginEpic from "./WorkforceOneSSOUserLoginEpic";
import WorkforceOneSSOTokenUserLoginEpic from "./WorkforceOneSSOTokenUserLoginEpic";

export const rootEpic: Epic<Action> = combineEpics(
    WorkforceOneUserAccess,
    WorkforceOneUserLoginEpic,
    WorkforceOneSSOUserLoginEpic,
    WorkforceOneSSOTokenUserLoginEpic,
    WorkforceOneUserPortalPermission,
    WorkforceOneUserAutoCompanySelectionEpic,
    WorkforceOneLoginPageReturn,
    WorkforceOneLogOutFromPasswordReset,
    WorkforceOneCompanySelectPageReturn,
    WorkforceOnePasswordResetRequest,
    WorkforceOneUpdateUserPortalPermission
) ;

